import ajax from '@/utils/ajax';

const header = '/web';
// 获取当前进行中的活动
export const reqNowAcvitity = () => ajax(`${header}/v1/sign-up/activity/get`);

// 获取活动奖品
export const reqAcvitityPrize = (id) => ajax(`${header}/v1/sign-up/activity/prize?id=${id}`);

// 领奖
export const reqReceivePrize = (data) => ajax(`${header}/v1/sign-up/activity/receive`, data, 'post');

// 视频详情页下推荐课程
export const reqRecommendCourse = (id) => ajax(`${header}/v1/sign-up/activity/recommend?id=${id}`);

// 批量查询有效的优惠券信息
export const reqCouponList = (id) => ajax(`${header}/v1/coupon/batch/select/valid?${id}`);

/// 视频播放统计
export const reqStatistics = (id) => ajax(`${header}/v1/sign-up/activity/statistics/${id}`);

// 注册活动获取活动奖品列表
export const reqNewzoneGift = () => ajax(`${header}/v1/sign-up/activity/prize-list`);

// 批量领奖
export const reqReceiveGift = (data) => ajax(`${header}/v1/sign-up/activity/receive/batch`, data, 'post');
